/* eslint-disable import/no-cycle */
import { IAddress } from './Address';
import { DisbursementMethod, EmployeeActionRequiredType, EmployeeStatus, EmployeeType, IEmployeeSiteSettings, SiteRole } from './Employee';
import { IJob } from './Job';

export interface IEmployerResponse {
  employers: IEmployer[];
}

export interface IEmployer {
  id: string;
  name: string;
  salesForce?: string;
  sites: IEmployerSite[];
  type: EmployeeType;
  createdAt: string;
  updatedAt: string;
}

interface IEmployerSiteEmployee {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
}

export interface IEmployerSite {
  actionRequired?: EmployeeActionRequiredType;
  address: IAddress;
  disbursementMethod?: DisbursementMethod;
  dismissReason?: string;
  employeeId?: string;
  id: string;
  job?: IJob;
  legalName: string;
  name: string;
  permissions: PermissionType[];
  role: SiteRole;
  salesForce?: string;
  employee: IEmployerSiteEmployee;
  settings: IEmployeeSiteSettings;
  status: EmployeeStatus;
  createdAt: string;
  updatedAt: string;
}

export enum PermissionType {
  SITE_VIEW = 'site_view',
  SITE_DAYSEGMENT_CREATE = 'site_daysegment_create',
  SITE_DAYSEGMENT_DELETE = 'site_daysegment_delete',
  SITE_DAYSEGMENT_UPDATE = 'site_daysegment_update',
  SITE_DAYSEGMENT_VIEW = 'site_daysegment_view',
  SITE_JOBS_VIEW = 'site_jobs_view',
  SITE_WITHHOLDINGS_UPDATE = 'site_withholdings_update',
  CALCULATOR_RULES_UPDATE = 'calculator_rules_update',
  CALCULATOR_RULES_VIEW = 'calculator_rules_view',
  CALCULATOR_CREDIT_CARD_FEE_UPDATE = 'calculator_credit_card_fee_update',
  CALCULATOR_SETTINGS_EXPORT = 'calculator_settings_export',
  CALCULATOR_SETTINGS_IMPORT = 'calculator_settings_import',
  GENERATE_CALCULATOR_RULES = 'generate_calculator_rules',
  GENERATE_SALES_CATEGORIES_GROUPS = 'generate_sales_categories_groups',
  GENERATE_DAY_SEGMENTS = 'generate_day_segments',
  GENERATE_HEALTH_REPORT = 'generate_health_report',
  EMPLOYEE_ONBOARDING_VIEW = 'employee_onboarding_view',
  EMPLOYEE_CREATE = 'employee_create',
  EMPLOYEE_DELETE = 'employee_delete',
  EMPLOYEE_UPDATE = 'employee_update',
  EMPLOYEE_VIEW = 'employee_view',
  EMPLOYEE_SITEROLE_CREATE = 'employee_siterole_create',
  EMPLOYEE_SITEROLE_DELETE = 'employee_siterole_delete',
  EMPLOYEE_SITEROLE_UPDATE = 'employee_siterole_update',
  PAYMENT_APPROVAL = 'payment_approval',
  PAYMENT_CANCEL = 'payment_cancel',
  PAYMENT_CREATE_CALCULATOR = 'payment_create_calculator',
  PAYMENT_CREATE_STANDARD = 'payment_create_standard',
  PAYMENT_CREATE_UPLOAD = 'payment_create_upload',
  PAYMENT_SUBMIT = 'payment_submit',
  PAYMENT_RETRY = 'payment_retry',
  PAYMENT_VIEW = 'payment_view',
  INTEGRATION_CREATE = 'integration_create',
  INTEGRATION_VIEW = 'integration_view',
  INTEGRATION_DELETE = 'integration_delete',
  INTEGRATION_UPDATE = 'integration_update',
  INTEGRATION_POS_DATA_VIEW = 'integration_pos_data_view',
  INTEGRATION_POS_CATEGORIES_DATA_VIEW = 'integration_pos_categories_data_view',
  INTEGRATION_POS_LABOR_DATA_VIEW = 'integration_pos_labor_data_view',
  INTEGRATION_POS_LABOR_DATA_UPDATE = 'integration_pos_labor_data_update',
  LEDGER_VIEW = 'ledger_view',
}

export interface IListEmployersOptions {
  includeActionRequired?: boolean;
  includeDismissed?: boolean;
  includeSalesforce?: boolean;
}
